import { db, getUser } from '@/firebaseApp';
import { UserRole } from '@/models/Enums';

// This is only for use in the UI, the db rules provide the real security
class Roles {
  async isAdmin() {
    const user = getUser();
    if (!user) {
      return false;
    } else {
      try {
        const doc = await db
          .collection(UserRole.Admin)
          .doc(user.uid)
          .get();
        return doc.exists;
      } catch (e) {
        if (e.code !== 'permission-denied') {
          console.error(e.message);
        }
        return false;
      }
    }
  }

  async isTeacher() {
    const user = getUser();
    if (!user) {
      return false;
    } else {
      const snapshot = await db
        .collection(UserRole.Teacher)
        .where('email', '==', user.email)
        .get();
      return !snapshot.empty;
    }
  }
}

export default new Roles();
